var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HMModalHeader',{attrs:{"title":_vm.$t('AFFILIATES.LABEL.PAYOUT_HISTORY')},on:{"close":function($event){return _vm.$emit('close')}}}),_c('HMTable',{staticClass:"mt-3",attrs:{"items":_vm.paymentHistory,"fields":_vm.paymentHistoryFelds},scopedSlots:_vm._u([{key:"payment_date",fn:function(ref){
var data = ref.data;
return [_c('h5',[_vm._v(_vm._s(_vm.formatDate(data.payment_date)))])]}},{key:"total",fn:function(ref){
var data = ref.data;
return [_c('span',[_vm._v(_vm._s(_vm.$formatCurrency(data.total, 'USD')))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }